import { TabHeader } from "../TabHeader/TabHeader";

/**
 * Legacy alias for the canonical `TabHeader` — kept so existing imports
 * in project-Settings pages (General, Annotation, Quality, Danger Zone,
 * Members, Webhooks, etc.) don't have to change. New code should import
 * `TabHeader` directly; this thin wrapper guarantees every settings
 * surface (project, org, platform) renders the same h2 + subtitle +
 * actions chrome.
 */
export const SettingsPageHeader = TabHeader;
